/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1SMOptions = {
    WorkoutComplete: 'workoutComplete',
    ProgrammeStarted: 'programmeStarted',
    ProgrammeOngoing: 'programmeOngoing',
    ProgrammeCompleted: 'programmeCompleted',
    ProgrammeLeave: 'programmeLeave',
    Rate: 'rate',
    Follow: 'follow',
    Trainee: 'trainee',
    AddedToWaitList: 'addedToWaitList',
    Received: 'received',
    ProfileView: 'profile_view',
    RequestClick: 'request_click',
    Created: 'created',
    Requested: 'requested',
    Paid: 'paid',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Abandoned: 'abandoned',
    Delivered: 'delivered',
    Disputed: 'disputed',
    Completed: 'completed',
    Reflection: 'reflection'
} as const
export type V1SMOptions = (typeof V1SMOptions)[keyof typeof V1SMOptions]

export function instanceOfV1SMOptions(value: any): boolean {
    for (const key in V1SMOptions) {
        if (Object.prototype.hasOwnProperty.call(V1SMOptions, key)) {
            if (V1SMOptions[key as keyof typeof V1SMOptions] === value) {
                return true
            }
        }
    }
    return false
}

export function V1SMOptionsFromJSON(json: any): V1SMOptions {
    return V1SMOptionsFromJSONTyped(json, false)
}

export function V1SMOptionsFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1SMOptions {
    return json as V1SMOptions
}

export function V1SMOptionsToJSON(value?: V1SMOptions | null): any {
    return value as any
}

export function V1SMOptionsToJSONTyped(
    value: any,
    ignoreDiscriminator: boolean
): V1SMOptions {
    return value as V1SMOptions
}
